// mport { REGEX_EMAIL_ADDRESS } from 'src/constants';
// import Lang from 'src/libraries/language';
import yup from 'src/libraries/validator.library';

const SettingShape = {
  key: yup.string().required(),
  value: yup.string().required(),
  description: yup.string(),
  editFlag: yup.boolean(),
  settingsId: yup.number().required(),
};

const SettingFormShape = {
  key: yup.string().required(),
  value: yup.string().required(),
  description: yup.string().required(),
  editFlag: yup.boolean(),
};

export const SettingSchema = yup
  .object()
  .shape({
    ...SettingShape,
  })
  .defined();

export const SettingListSchema = yup
  .object({
    count: yup.number(),
    rows: yup
      .array()
      .of(
        yup
          .object()
          .shape({
            ...SettingShape,
          })
          .defined()
      )
      .defined(),
  })
  .defined();

export const SettingFormSchema = yup
  .object()
  .shape({
    ...SettingFormShape,
  })
  .defined();

export const SettingPayloadSchema = yup
  .object({
    configSetting: yup.object(SettingShape).defined(),
  })
  .defined();

export type ISetting = yup.InferType<typeof SettingSchema>;
export type ISettingList = yup.InferType<typeof SettingListSchema>;
export type ISettingForm = yup.InferType<typeof SettingFormSchema>;
